module.exports = __webpack_public_path__ + "img/git-pull-request.9323a800.svg";